import {Component, OnInit} from '@angular/core';
import {HeizkostenabrechnungStepComponent} from "./heizkostenabrechnung.step.component";
import {HeizkostenabrechnungForm} from "./heizkostenabrechnung.form";

/**
 * Custom Step for the input of consumption
 *
 * @inheritDoc
 */
@Component({
    selector: 'app-step-heizkostenabrechnung-verbrauchseingabe',
    templateUrl: './heizkostenabrechnung.grouped.step.component.html',
    standalone: false
})
export class HeizkostenabrechnungVerbrauchseingabeStepComponent extends HeizkostenabrechnungStepComponent implements OnInit {

  /**
   * @inheritDoc
   */
  formConfig: HeizkostenabrechnungForm;

  ngOnInit() {
    super.ngOnInit();
    this.formConfig.anfrage = this.anfrage;
    // do not show step help
    this.hasHelp = false;

    // init subheadlines for the current step
    this.initSubheadlines();

    // if there are changes in the form, reset the warnings
    this.subscriptions.push(this.form.valueChanges.subscribe(() => {
      this.formWarning = null;
    }));
  }

  /**
   * @inheritDoc
   */
  moveToNextStep(): void {
    this.calculateBuildingconsumption();
  }

  /**
   * sends the data for the building to the backend to calculate the evkw of the building as first validation.
   */
  calculateBuildingconsumption(): void {
    this.loading = true;
    this.formError = null;
    this.invoiceErrors = null;

    this.requestService.backendService.getRequestId().subscribe(requestId => {
      const input = this.anfrage.heizkostenanalyseInput;

      this.requestService.backendService.verbrauchsanalyseHeizkostenabrechnung(input, requestId).subscribe(response => {
        this.loading = false;

        // check response from the backend
        if(response?.result?.status?.code === 0) {
          // save result and move to the next step
          this.anfrage.verbrauchsanalyseResult = response.result;
          this.requestService.setAnfrage(this.anfrage);

          // check if there is a warning and if we want to sho this
          if(!this.formWarning && response.result.status.warnings.length > 0 && response.result.status.warnings[0].code) {
            this.formWarning = response.result.status.warnings[0].code;
            switch(this.formWarning) {
              case 'energy_price_too_high':
              case 'energy_price_too_low':
                this.warningFields = ['energietraeger_kosten'];
                break;
              default:
                this.warningFields = response.result.status.warnings[0].affected_fields.map(field => field.replace('abrechnungen.0.', ''));
                break;
            }

            // set placeholder for warning
            this.warningPlaceholder = response.result.placeholder;

            return;
          }

          // show next step
          super.moveToNextStep();
          return;
        }
        else {
          // there is an error
          this.formWarning = null;
          this.showValidationErrors(response.result);

          this.elementService.scrollToElement(this.stepForm.nativeElement);
        }
      }, error => {
        this.loading = false;

        if(error?.status === 400) {
          this.showValidationErrors(error);
        }
        else {
          // generic error, mostly on the connection to the backend.
          this.formError = 'connection';
        }
        this.elementService.scrollToElement(this.stepForm.nativeElement);
      });
    });
  }

  /**
   * Shows validatiomn error on one single invoice.
   * @param result
   */
  showValidationErrors(result: any): void {
    // reset errors
    this.formWarning = null;
    this.invoiceErrors = null;
    this.backendErrors = null;

    if(result?.status === 400) {
      this.invoiceErrors = {error: 'input', fields: result.error?.result?.status?.errors[0]?.affected_fields || []};
      // show specific error message, based on backend reply
      this.backendErrors = result.error?.result?.status ? result.error.result.status.errors.map(error => {
        return this.textkeyPrefix + '.verbrauchsanalyse.verbrauchsdaten.error.' + error.code + '|heizkostenabrechnung';
      }) : [];
    }
    else {
      // generic error, mostly on the connection to the backend.
      this.formError = 'connection';
    }
  }

}

